import { useI18n } from 'vue-i18n'

const NS = 'visualGameAdmin.novelErrors'
// 业务错误的原因码是 snake_case（novel-repo 的 conflict('pack_content_invalid') 放在 message 里），错误类别是大写的 code。
const REASON_CODE = /^[a-z][a-z0-9_]*$/

/** 小说后台各页共用的取词：接口错误转文案，时间按界面语言显示。 */
export function useNovelPageText() {
  const { t, te, locale } = useI18n()

  /**
   * 接口错误转文案：先认原因码，再认错误类别；都没收录时是"未归类错误"。原码放在 title 里备查。
   * @param {any} error
   * @returns {{ text: string, title: string, known: boolean }}
   */
  function apiError(error) {
    const message = typeof error?.message === 'string' ? error.message : String(error)
    const code = typeof error?.code === 'string' ? error.code : ''
    const title = [code, message].filter(Boolean).join(' · ')
    for (const reason of [message, code].filter((value) => REASON_CODE.test(value))) {
      if (te(`${NS}.reasons.${reason}`)) return { text: t(`${NS}.reasons.${reason}`), title, known: true }
    }
    if (code && te(`${NS}.codes.${code}`)) return { text: t(`${NS}.codes.${code}`), title, known: true }
    return { text: t(`${NS}.unknown`), title, known: false }
  }

  /** 提示条和确认框里没有 title 可放：未归类的错误把原码接在文案后面。 */
  function apiErrorLine(error) {
    const { text, title, known } = apiError(error)
    return known || title === '' ? text : `${text} · ${title}`
  }

  function dateTime(value) {
    return new Date(value).toLocaleString(locale.value, { dateStyle: 'short', timeStyle: 'short' })
  }

  return { apiError, apiErrorLine, dateTime }
}
